module.exports = __webpack_public_path__ + "static/media/Davin Suggs_1610009568457.b34cc331.png";